import styled from 'styled-components';
import { mqSmallMin, mqSmallMax, mqLargeMin } from 'styled/tools/media-queries';
import {
  WithFontHead,
  WithSiteLayout,
  WithSiteLayoutPadding,
  WithSiteLayoutWidth,
} from 'styles/commonCss';

export const Hero = styled.div<{ $adjustRight?: boolean }>`
  display: flex;
  justify-content: center;
  margin: 0 0 var(--spacing-48) 0;

  > .container {
    position: relative;
    display: block;
  }
  * {
    color: var(--text-primary);
  }

  .title {
    ${WithSiteLayout};
    padding-top: var(--spacing-24);
    padding-bottom: var(--spacing-24);
    display: block;

    @media ${mqLargeMin} {
      width: calc(100% - 60px);
      transform: translate(-50%, -50%);
      padding: 0;
      position: absolute;
      z-index: 2;
      pointer-events: none;
      left: 50%;
      top: 45%;
    }
  }

  .title .container {
    display: block;

    @media ${mqLargeMin} {
      padding: 0 var(--spacing-48);
    }
  }

  .title .container h1 {
    ${WithFontHead};
    display: inline-block;
    font-size: 26px;

    letter-spacing: var(--flag-letter-spacing-1);
    @media ${mqSmallMin} {
      letter-spacing: var(--flag-letter-spacing-2);
    }

    @media ${mqLargeMin} {
      display: block;
      font-size: 40px;
    }
  }

  .srpCouponAmount {
    background-color: #e9f0ca;
    border-radius: 24px;
    width: 70px;
    height: 18px;
    font-size: 12px;
    padding: 4px 8px 4px;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    align-items: center;
    font-weight: 500;
    margin-left: 8px;
    margin-top: -2px;
    line-height: 12px;
  }

  .most-popular-pill {
    background-color: #1c3a13;
    border-radius: 24px;
    color: #ffffff;
    width: 90px;
    height: 18px;
    font-size: 12px;
    padding-top: 4px;
    vertical-align: middle;
    text-align: center;
    align-items: center;
    font-weight: 500;
    margin-left: 8px;
    margin-top: -2px;
    line-height: 12px;
    display: none;
  }

  .srp0title .container {
    display: block;

    @media ${mqSmallMax} {
      margin-left: -30px;
    }
  }

  .srp0title .container h1 {
    ${WithFontHead};
    display: inline-block;
    font-size: 26px;

    letter-spacing: var(--flag-letter-spacing-1);
    @media ${mqSmallMin} {
      letter-spacing: var(--flag-letter-spacing-2);
    }

    @media ${mqLargeMin} {
      display: block;
      font-size: 40px;
    }
  }

  .site-buy {
    padding-left: 0px;
    padding-right: 0px;

    .list {
      margin: var(--spacing-24) 0 0;

      li {
        font-size: 14px;
        line-height: 1.75;
      }
    }

    .cta-button {
      width: 100%;
      margin: var(--spacing-8) 0 0;
      color: var(--actions-inverse);

      * {
        color: var(--actions-inverse);
      }
    }
  }

  .hero > .container {
    display: flex;
    flex-direction: column;
    background-color: var(--fill-primary);
    height: 100%;
    width: 100%;
    margin-bottom: 10px;
  }

  .hero .media {
    ${WithSiteLayoutPadding};
    margin-right: auto;
    margin-left: auto;
    position: relative;
    display: block;
    width: 100%;
    overflow: hidden;
  }

  .hero .media .img {
    position: relative;
    display: none;
    width: 100%;

    &.sm {
      display: block;
    }

    @media ${mqLargeMin} {
      &.lg {
        display: block;
      }

      &.sm {
        display: none;
      }
    }
  }

  .srpHero .srp0media {
    @media ${mqLargeMin} {
      width: 50vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .img {
      position: relative;
      display: none;
      width: 100%;

      &.sm {
        display: block;
      }

      @media ${mqLargeMin} {
        &.lg {
          display: block;
          left: -20%;
          scale: 2.2;
        }

        &.sm {
          display: none;
        }
      }
    }
  }

  #expanding-selector {
    margin-top: 24px;
    display: none;
  }

  .hero .text {
    ${WithSiteLayoutWidth};
    ${WithSiteLayoutPadding};
    padding-top: 30px;
    z-index: 1;

    @media ${mqLargeMin} {
      transform: translateX(-50%);
      position: absolute;
      left: 50%;
      top: 29.5%;
    }
  }

  .srpHero .srp0text {
    ${WithSiteLayoutWidth};
    padding-top: 30px;
    z-index: 1;

    @media ${mqLargeMin} {
      position: relative;
      right: ${({ $adjustRight }) => ($adjustRight ? '0' : '50px')};
      top: 15%;
      max-width: 432px;
    }

    display: flex;
    flex-direction: column;
  }

  .planSelector {
    display: flex;
    flex-direction: column;
    margin-top: 24px;

    .inputContainer {
      z-index: 1000;
      margin: 10px 0px;
      padding: 10px;
      border: 1px solid #d2d8d0;
      cursor: pointer;
    }

    .selectedInputContainer {
      z-index: 1000;
      margin: 10px 0px;
      padding: 10px;
      border: 1px solid #d2d8d0;
      cursor: pointer;
      background-color: #d2d8d0;
    }

    .productTitle {
      font-weight: 500;
    }

    h2 {
      padding: 0px !important;
      line-height: 1;
      pointer-events: none;
    }

    .radioContent {
      pointer-events: none;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      vertical-align: top;
    }

    input[type='radio']:checked {
      accent-color: #1c3a13;
    }

    input[type='radio'] {
      background: #d2d8d0;
      margin-top: 25px;
      margin-right: 0;
      transform: none;
    }

    .radioContent .srpPrice {
      font-size: 16px;
      font-weight: 500;
    }

    .radioContent .srpPriceCrossed {
      font-size: 14px;
      font-weight: 500;
      text-decoration: line-through;
      color: #778971;
    }

    .radioContent .srpPriceContainer {
      pointer-events: none;
      height: 62px;
      margin-top: -46px;
    }

    .radioContent .srpBillingPeriod {
      font-size: 12px;
      font-family: var(--flag-font-family);
      font-weight: 400;
      letter-spacing: normal;
      font-style: normal;
      line-height: 16px;
      color: '#1C3A13';
    }

    .radioContent .srpProductDescription {
      font-size: 12px !important;
      font-family: var(--flag-font-family);
      font-weight: 400;
      letter-spacing: normal;
      font-style: normal;
      line-height: 16px;
      color: '#1C3A13';
    }

    .radioContent .srpDescriptionContainer {
      margin-left: 26px;
      display: block;
      margin-top: -46px;
    }

    .radioContent .srpDiscountSvg {
      padding: 3px 0px 0px 6px !important;
      overflow: visible;
      shape-rendering: crispEdges;
    }
  }

  .srpHero .srp0text .srp0title p {
    display: none;
  }

  .hero .text > .container {
    @media ${mqLargeMin} {
      width: 302px;
      max-width: 100%;
      float: right;
    }
  }

  .hero .text {
    b {
      display: block;
      margin: 0 0 10px;
    }

    p {
      display: block;
      font-size: 16px;
    }

    h2,
    h6 {
      display: block;
      font-size: 13px;
      padding-top: var(--spacing-8);
      font-weight: 400;
      line-height: 1.5;
    }
  }

  .srpHero {
    @media ${mqLargeMin} {
      position: relative;
      width: 100%;
      max-width: 1440px;
      justify-content: space-around;
      display: flex;
      padding: 0;
      min-height: 750px;
    }

    .srp0text {
      b {
        display: block;
        margin: 0 0 10px;
      }

      h2,
      h6 {
        display: block;
        font-size: 13px;
        padding-top: var(--spacing-8);
        font-weight: 400;
        line-height: 1.5;
      }
    }
  }

  .cursor-nav {
    flex-wrap: wrap;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2;
    top: -40px;
    border: 1px;
    display: flex;
    align-items: center;
    height: 20px;
  }

  .cursor-nav-prev,
  .cursor-nav-next {
    background: transparent;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .cursor-nav-prev {
    margin-right: 12px;
    transform: rotate(-180deg);
    position: relative;
    top: 1px;
  }
`;

export const SmHeroImage = styled.div`
  @media (max-width: 480px) {
    span > img {
      top: -89px !important;
    }
  }
`;

export const Srp0Text = styled.div`
  @media (max-width: 480px) {
    margin-top: 0;
    position: relative;
    z-index: 2;
  }

  p {
    display: block;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;

    @media (max-width: 480px) {
      line-height: 20px;
    }
  }
`;

export const Srp0Title = styled.div`
  ${WithSiteLayout}
  padding-top: var(--spacing-24);
  padding-bottom: var(--spacing-24);
  display: block;
  @media ${mqLargeMin} {
    padding: 0;
    z-index: 2;
    pointer-events: none;
    left: 50%;
    top: 45%;
  }

  @media (max-width: 480px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  @media (min-width: 30em) {
    padding-left: 0px;
  }
`;

export const SchedulePickerContainer = styled.div`
  height: 82px;
  margin: 32px 0px 24px 0px;

  @media (max-width: 480px) {
    margin: 12px 0 8px;
  }
`;

export const SchedulePickerHeader = styled.div`
  font-weight: 500;
  color: '#1C3A13';
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 4%;
  margin-bottom: 16px;

  @media (max-width: 480px) {
    margin-bottom: 8px;
  }
`;
